export const DIALOG_AUTO_FOCUS_ATTRIBUTE = 'data-dialog-autofocus';

export const DIALOG_AUTO_FOCUS_SELECTOR = `[${DIALOG_AUTO_FOCUS_ATTRIBUTE}="true"]`;
